import { MutationHookOptions } from '@apollo/client'
import { TrainingClassMembershipsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  DeleteTrainingClassMembershipsDocument,
  DeleteTrainingClassMembershipsMutation,
  DeleteTrainingClassMembershipsMutationVariables,
  TrainingClassMembershipsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  DeleteTrainingClassMembershipsMutation,
  DeleteTrainingClassMembershipsMutationVariables
>

export const useDeleteTrainingClassMembership = (options?: Options) => {
  const [bulkDeleteTrainingClassMemberships, { loading }] = useMutation(
    DeleteTrainingClassMembershipsDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.bulkDeleteTrainingsTrainingClassMembership,
    }
  )

  return {
    loading,
    deleteTrainingClassMemberships(variables: DeleteTrainingClassMembershipsMutationVariables) {
      return bulkDeleteTrainingClassMemberships({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          TrainingClassMembershipsDatatableDocument,
          TrainingClassMembershipsDataCollectionDocument,
        ],
      })
    },
  }
}
